import {mapActions, mapGetters} from 'vuex'

import {clientMixin} from '@/mixins/clientMixin'

import { map } from 'ramda'

export const campaignMixin = {
  mixins: [clientMixin],
  computed: {
    ...mapGetters({
      'campaigns': 'campaigns/all',
      'clientCampaigns': 'campaigns/clientCampaigns',
      'campaign': 'campaigns/campaign'
    })
  },
  created () {
    this.getClients().then(() => {
      this.clientOptions = map((item) => {
        return {
          value: item.hash_id,
          name: item.name
        }
      }, this.clients)
    })
  },
  methods: {
    ...mapActions({
      'getCampaigns': 'campaigns/getCampaigns',
      'addCampaign': 'campaigns/addCampaign',
      'getCampaign': 'campaigns/getCampaign',
      'updateCampaign': 'campaigns/updateCampaign',
      'deleteCampaign': 'campaigns/deleteCampaign',
      'cloneCampaign': 'campaigns/cloneCampaign',
      'getClientCampaigns': 'campaigns/getClientCampaigns'
    })
  },
  data: () => ({
    clientOptions: [],
    steps: {
      options: ['Campaign', 'Creative', 'Fields']
    }
  })
}



// WEBPACK FOOTER //
// ./src/mixins/campaignMixin.js